import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const CustomersList = ({ customers, onDeleteCustomer, onOpenCustomerModal, onSelectCustomer }) => {
  const { t } = useTranslation();
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [activeCustomerId, setActiveCustomerId] = useState(null);

  const handleSelectCustomer = (customer) => {
    onSelectCustomer(customer, selectedCustomer);
    setSelectedCustomer(customer);
    setActiveCustomerId(customer.customer_id);
  };

  return (
    <div className="customers-list">
      <ul className="list-group">
        <button className='btn btn-primary-custom w-100 mx-0 mb-0' onClick={onOpenCustomerModal}>
          <i className="bi bi-person-plus fs-5 px-2"></i>{t('new_customer')}
        </button>
        {customers.map(customer => (
          <li className="w-100" key={customer.customer_id}>
            <div className={`button-wrapper d-flex justify-content-between align-items-center ${activeCustomerId === customer.customer_id ? 'active' : ''}`} onClick={() => handleSelectCustomer(customer)}>
              <span className={`btn btn-link ${activeCustomerId === customer.customer_id ? 'fw-600' : ''}`}>
                <i className="bi bi-buildings fs-5 color-primary-95 mx-2"></i>
                {customer.name}
              </span>
                <button
                  type="button"
                  className='btn btn-light mb-0'
                  onClick={(event) => {
                    event.stopPropagation();
                    onDeleteCustomer(customer.customer_id);
                  }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label={t('delete_customer_named', { name: customer.name })}
                  title={t('delete_customer')}
                  ><i className="bi bi-trash"></i>
                </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CustomersList;
